module.exports = __webpack_public_path__ + "static/media/paper_style1.cd6d667c.png";